webpackJsonp([30678390257340],{

/***/ 542:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _LoreHookAuth = __webpack_require__(34);
	
	var _LoreHookAuth2 = _interopRequireDefault(_LoreHookAuth);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _LoreHookAuth2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Config'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      module.exports = {\n\n        /**\n         * The name of the model with a URL property set to the endpoint\n         * that can return the current user.\n         */\n        modelName: \'currentUser\'\n\n        /**\n         * The name of the reducer that should be created that is responsible\n         * for storing the current user. This defaults to the name of the\n         * model.\n         */\n        reducerName: \'currentUser\'\n\n        /**\n         * The name of the action that should be created at this responsible\n         * for fetching the current user. This defaults to the name of the\n         * model.\n         */\n        actionName: \'currentUser\'\n\n      };\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-hooks-lore-hook-auth-config-index-js-d69747bf89c6e9eca353.js